import type { Integrations } from '@lokalise/translation-api-schemas'

export type AiConfigModelDetail = {
  integration: Integrations
  name: string
  description: string
}

type AiConfigModelResult = {
  details: AiConfigModelDetail[] | null
  isLoading: boolean
}

const STATIC_DETAILS: AiConfigModelDetail[] = [
  { integration: null, name: 'Routing', description: 'Dynamic LLM switching' },
  { integration: 'gpt', name: 'GPT', description: 'OpenAI LLM' },
  { integration: 'claude', name: 'Claude', description: 'Anthropic LLM' },
  { integration: 'gemini', name: 'Gemini', description: 'Google Gemini LLM' },
]

/**
 * This hook is designed to be extendable so that in the future
 * we can add a server call for this information without needing
 * to change the public API of the hook itself
 */
export const useAiConfigModels = (): AiConfigModelResult => ({
  isLoading: false,
  details: STATIC_DETAILS,
})
